"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fonts = void 0;
const Fonts_1 = require("./Fonts");
exports.fonts = new Fonts_1.Fonts();
